import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { Modalable } from "@app/Modalable"
import { ApiService } from "@app/services/api.service"
import { LangService } from "@app/services/lang.service"
import { ModalService } from "@app/services/modal.service"
import { StoreService } from "@app/services/store.service"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { BtnExtComponent } from "@app/utils/utils.component"

const defaultName = "file.pdf"

@Component({
	selector: "app-document-password",
	imports: [COMMON_IMPORTS, LangValPipe, GenInputComponent, BtnExtComponent],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div
			class="align-content-center"
			style="min-height: 70svh"
		>
			<div
				class="prompt-text text-center"
				style="font-size: 24px; letter-spacing: -.5px"
			>
				@if (isSuccess) {
					{{ "download_success" | langVal }}
				} @else if (isSent) {
					{{ "download_process" | langVal }}
				} @else {
					{{ "enter_password_to_open_document" | langVal }}
				}
			</div>
			@if (!isSent) {
				<div class="prompt-input">
					<app-gen-input
						[actualObj]="this"
						fieldName="pass"
						autofocus="autofocus"
						autocomplete="off"
					/>
				</div>
				<div class="text-center">
					<app-btn-ext
						(clickEv)="submit()"
						text="to_download_document"
						[disabled]="!pass"
					/>
				</div>
			}
		</div>
	`,
})
export class DocumentPasswordComponent {
	pass: string = ""
	isSent: boolean = false
	isSuccess: boolean = false

	constructor(
		public apiService: ApiService,
		public modalService: ModalService,
		public store: StoreService,
		public lang: LangService
	) {}

	getName(s: string) {
		if (!s) {
			return defaultName
		}
		const [, name] = s.split("filename=")
		return name ? name.replaceAll('"', "") : defaultName
	}
	async submit() {
		this.isSent = true
		const res = await this.apiService.downloadWithHeaders(
			"get_documents_by_password",
			{
				pass: this.pass,
			}
		)
		const isPdf = res.headers.get("Content-Type") === "application/pdf"
		if (!isPdf) {
			this.modalService.openToast(await res.body.text())
			this.isSent = false
			return
		}

		const name = this.getName(res.headers.get("Content-Disposition"))
		const body = res.body

		if (!body?.size) {
			return this.store.downloadFailedModal()
		}
		this.apiService.downloadFile(body, name)
		this.modalService.openToast("downloaded_documents")
		this.isSuccess = true
	}
}
